// @ts-nocheck
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box } from '../Box';
import { IconField } from '../IconField';
var paddingTopWithLabel = {
    sm: '14px',
    md: '16px',
    lg: '20px',
    xl: '24px',
};
var paddingBottomWithLabel = {
    sm: '0px',
    md: '5px',
    lg: '8px',
    xl: '13px',
};
var paddingTopForLabel = {
    sm: '0px',
    md: '2px',
    lg: '6px',
    xl: '10px',
};
var inputPaddingTop = function (size) {
    return (paddingTopWithLabel === null || paddingTopWithLabel === void 0 ? void 0 : paddingTopWithLabel[size]) ? paddingTopWithLabel[size] : '20px';
};
var inputPaddingBottom = function (size) {
    return (paddingBottomWithLabel === null || paddingBottomWithLabel === void 0 ? void 0 : paddingBottomWithLabel[size]) ? paddingBottomWithLabel[size] : '8px';
};
var labelPaddingTop = function (size) {
    return (paddingTopForLabel === null || paddingTopForLabel === void 0 ? void 0 : paddingTopForLabel[size]) ? paddingTopForLabel[size] : '6px';
};
var FormField = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var iconBefore = false;
    var childrenArray = React.Children.toArray(children);
    var field = childrenArray.filter(function (child) { return child.type.isField; })[0];
    var label = childrenArray.filter(function (child) { return child.type.isLabel; })[0];
    var valueNoLabel = !label && field && !!field.props.value;
    var showLabel = ((label && !label.props.autoHide) || (field && !!field.props.value)) && !valueNoLabel;
    var id = field && (field.props.id || field.props.name);
    var inputSize = field && (field.props.size || undefined);
    var styled = childrenArray.map(function (child, i, arr) {
        if (child.type.isField && arr[i - 1] && arr[i - 1].type.isIcon) {
            iconBefore = true;
        }
        if (child === field) {
            return React.cloneElement(child, {
                id: id,
                style: __assign(__assign({}, child.props.style), { transitionProperty: 'padding-top, padding-bottom', transitionDuration: '.1s', paddingTop: showLabel ? inputPaddingTop(inputSize) : undefined, paddingBottom: showLabel ? inputPaddingBottom(inputSize) : undefined }),
            });
        }
        return child;
    });
    var ml = iconBefore ? '40px' : '12px';
    var styledLabel = label &&
        React.cloneElement(label, {
            htmlFor: label.props.htmlFor || id,
            fontSize: 10,
            ml: ml,
            pt: labelPaddingTop(inputSize),
            mb: '-20px',
            style: __assign(__assign({}, label.props.style), { height: 20, transitionProperty: 'opacity', transitionDuration: '.1s', opacity: showLabel ? 1 : 0, pointerEvents: 'none', position: 'relative', width: "calc(100% - ".concat(ml, ")") }),
        });
    return (React.createElement(Box, __assign({}, props),
        styledLabel,
        React.createElement(IconField, null, styled)));
};
FormField.displayName = 'FormField';
export default FormField;
//# sourceMappingURL=FormField.js.map